/**
 * Trust account activity type enum
 * Categorizes events that appear in the trust account activity feed
 */
export enum TrustAccountActivityType {
  BUYER_DEPOSIT = 'buyer_deposit',
  BUYER_OVERPAYMENT = 'buyer_overpayment',
  TRUST_PAYOUT = 'trust_payout',
  PAYMENT_INSTRUCTION_SENT = 'payment_instruction_sent',
  PAYOUT_INSTRUCTION_SENT = 'payout_instruction_sent',
  BUYER_ADDED = 'buyer_added',
  BUYER_REMOVED = 'buyer_removed',
  BENEFICIARY_ADDED = 'beneficiary_added',
  BENEFICIARY_REMOVED = 'beneficiary_removed',
  DOCUMENT_ADDED = 'document_added',
  DOCUMENT_UPDATED = 'document_updated',
  DOCUMENT_REMOVED = 'document_removed'
}
